// Preferencias de la interfaz que se recuerdan en este navegador (localStorage),
// todas bajo una misma clave. No viajan al backend: son por dispositivo.
const CLAVE = "preferencias";

function todas() {
  try {
    return JSON.parse(localStorage.getItem(CLAVE)) || {};
  } catch (error) {
    // Sin localStorage (modo privado) o con un valor dañado se parte de cero.
    return {};
  }
}

export function leerPreferencia(nombre, porDefecto) {
  const valor = todas()[nombre];
  return valor === undefined ? porDefecto : valor;
}

export function guardarPreferencia(nombre, valor) {
  try {
    localStorage.setItem(CLAVE, JSON.stringify({ ...todas(), [nombre]: valor }));
  } catch (error) {
    // Si no se puede guardar, la preferencia dura lo que dure la página.
  }
}
